export default __webpack_public_path__ + "static/media/phishing.c8020a5a.svg";